<template>
  <v-footer
    color="primary lighten-1"
    padless
  >
    <v-row
      justify="center"
      no-gutters
    >
<!--      <v-btn-->
<!--        v-for="link in links"-->
<!--        :key="link"-->
<!--        color="white"-->
<!--        text-->
<!--        rounded-->
<!--        class="my-2"-->
<!--      >-->
<!--        {{ link }}-->
<!--      </v-btn>-->
      <v-col
        class="primary py-4 text-center white--text"
        cols="12"
      >
        {{ new Date().getFullYear() }} — <strong>Powered by DAE Labs</strong>
        <v-spacer/>
        <a style="color: #dddddd" href="https://escuela.intrare.app/notice_privacy" target="_blank">Aviso de privacidad</a>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
    export default {
        name: "Foot"
    }
</script>

<style scoped>

</style>
